import PropTypes from 'prop-types';
// @flow

import React from 'react';

import I18n from 'PMT/i18n/I18n';

import Config from 'constants/Config';
import RoutingEnum from 'constants/RoutingEnum';

import Link from 'PMT/components/Link';
import { PasswordInput } from 'PMT/components/form';

import AbstractComponent from 'components/AbstractComponent';

import HibpPassword from './HibpPassword';

export default class LoginForm extends AbstractComponent {
  static propTypes = {
    onLogin: PropTypes.func,
  };

  constructor() {
    super();

    if (!Config.IS_PREPROD && !Config.IS_PROD) {
      this.state = {
        //username: '15000603', // Zelty PMT
        //        username: '15000403', // Resto Démo
        password: '',
      };
    } else {
      this.state = {
        username: '',
        password: '',
      };
    }
  }

  onUsernameChange = () => {
    this.setState({
      username: this.refs.username.value,
    });
  };

  onPasswordChange = value => {
    this.setState({
      password: value,
    });
  };

  onSubmit = (event: Object) => {
    event.preventDefault();
    this.props.onLogin(this.state.username, this.state.password);
  };

  render(): Object {
    return (
      <form className="login_page__login_form form-horizontal">
        <div className="row">
          <div className="col-xs-12 col-sm-8 col-sm-offset-2">
            <input
              type="email"
              defaultValue={this.state.username}
              name="username"
              ref="username"
              placeholder={I18n.tr('login.form.username')}
              onChange={this.onUsernameChange}
              className="form-control big-form-control"
            />
          </div>
        </div>

        <div className="row top-buffer-30">
          <div className="col-xs-12 col-sm-8 col-sm-offset-2">
            <PasswordInput
              onChange={this.onPasswordChange}
              value={this.state.password}
              placeholder={I18n.tr('login.form.password')}
              className="form-control big-form-control"
            />
            <HibpPassword
              displayCheckSecure={false}
              displayIsSecureMessage={false}
              password={this.state.password}
              pwnedText={I18n.tr('login.form.password.should_choose_another')}
            />
            <div className="text-right">
              <Link to={RoutingEnum.FORGOT_PASSWORD}>
                {I18n.tr('login.form.forgot_password')}
              </Link>
            </div>
          </div>
        </div>

        <div className="col-xs-12 col-sm-8 col-sm-offset-2 text-center top-buffer-50">
          <button
            type="submit"
            className="btn btn-primary"
            onClick={this.onSubmit}
          >
            {I18n.tr('login.form.connect')}
          </button>
        </div>
      </form>
    );
  }
}



// WEBPACK FOOTER //
// ./scripts/pages/login/components/LoginForm.js